module.exports = __webpack_public_path__ + "static/media/1 - Allah Las - Raspberry Jam.40ed5ebd.mp3";